module.exports = __webpack_public_path__ + "static/media/project.a49df486.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vector/project.svg
// module id = 302
// module chunks = 0